import Vue from 'vue'
import { API_URL } from '@/config'

export const meetings = {

  namespaced: true,

  state: {
    meetings: [],
  },

  getters: {
    meetings: state => state.meetings,
  },

  mutations: {
    setMeetings(state, meetings) { state.meetings = meetings },
    clearList(state) {
      state.meetings = [];
    },
  },

  actions: {

    getMeetings: () => Vue.axios.get(API_URL + '/meetings', { params: {
      sorts: [{"column":"id","order":"asc"}]
    }}),

    async getList({ commit, dispatch }) {
      const meetings = await dispatch('getMeetings');
      commit('setProgress', false, { root: true });
      commit('setMeetings', meetings.data.items);
    },

  }
}
